import { useState, useEffect } from 'react';
import './i18n';
import AccessGate from './components/AccessGate';
import LanguageSwitcher from './components/LanguageSwitcher';
import HeroSection from './components/HeroSection';
import Timeline from './components/Timeline';
import PhotoUpload from './components/PhotoUpload';
import EventLocation from './components/EventLocation';
import FAQ from './components/FAQ';
import RSVPForm from './components/RSVPForm';
import { useTranslation } from 'react-i18next';

function App() {
  const [accessGranted, setAccessGranted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const granted = sessionStorage.getItem('accessGranted');
    if (granted === 'true') {
      setAccessGranted(true);
    }
  }, []);

  if (!accessGranted) {
    return <AccessGate onAccessGranted={() => setAccessGranted(true)} />;
  }

  return (
    <div className="App">
      <LanguageSwitcher />
      <HeroSection />
      <Timeline />
      <PhotoUpload />
      <EventLocation />
      <FAQ />
      <RSVPForm />
      
      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-gray-400">
            {t('footer')}
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;